function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.938 1H3.061a.563.563 0 00-.562.563v.375c0 .31.252.562.563.562 0 2.132 1.195 3.931 2.832 4.5-1.637.569-2.832 2.368-2.832 4.5a.562.562 0 00-.563.563v.374c0 .311.252.563.563.563h7.874c.311 0 .563-.252.563-.563v-.374a.562.562 0 00-.563-.563c0-2.132-1.195-3.931-2.832-4.5 1.637-.569 2.832-2.368 2.832-4.5.311 0 .563-.252.563-.563v-.375A.562.562 0 0010.937 1zm-1.76 9H4.822C5.222 8.903 6.043 8.125 7 8.125c.957 0 1.778.778 2.178 1.875zm0-6H4.822a4.397 4.397 0 01-.26-1.5h4.875c0 .534-.093 1.045-.259 1.5z",
  fill: "currentColor"
});

var SvgPending3 = function SvgPending3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgPending3;